import { useEffect } from 'react';

import { useRentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { ErrorMessageConstants } from '@zg-rentals/zillow-rental-manager/constants';

import type { Dispatch } from 'react';
import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { ListingErrorsReducerProps, ListingReducerProps } from '../../components/modals/AddPropertyModal/reducers';

const useContracts = (
  setListing: Dispatch<{ type: keyof ListingReducerProps; payload: unknown }>,
  setErrorObj: Dispatch<ListingErrorsReducerProps>,
  setIsSubmitDisabled: (value: boolean) => void,
  user?: Pick<RentalManagerAuthCheckUserInfoWebApiDto, 'isSingleFamilyEnterpriseCustomer' | 'userManagementCompanyId'>,
) => {
  const shouldGetSFContracts = user?.isSingleFamilyEnterpriseCustomer && user?.userManagementCompanyId;

  const { data: contractsData, refetch: refetchContracts } =
    useRentalManagerUserSingleFamilyEnterpriseContractWebApiHandler_contracts({
      enabled: false,
    });

  useEffect(() => {
    if (!shouldGetSFContracts) return;

    const fetchContracts = async () => {
      setIsSubmitDisabled(true);
      try {
        const { data: contractsData } = await refetchContracts();

        if (contractsData) {
          setIsSubmitDisabled(false);

          if (contractsData.contracts.length === 1) {
            setListing({
              type: 'customerId',
              payload: contractsData.contracts[0].customerId,
            });
          }
        }
      } catch {
        setIsSubmitDisabled(true);
        setErrorObj({ type: 'customerId', payload: ErrorMessageConstants.SINGLE_FAMILY_CANNOT_RETRIEVE_CONTRACTS });
      }
    };

    fetchContracts();
  }, [user, shouldGetSFContracts, refetchContracts, setListing, setErrorObj, setIsSubmitDisabled]);

  return contractsData;
};

export { useContracts };
